declare namespace $ {

	export class $mol_icon_cards extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=cards.view.tree.d.ts.map